import React, { useEffect, useState, createContext, useContext } from 'react';
import { Exchange } from '../types';
interface CompareContextType {
  compareList: Exchange[];
  addToCompare: (exchange: Exchange) => void;
  removeFromCompare: (id: string) => void;
  clearCompare: () => void;
  isInCompare: (id: string) => boolean;
}
const CompareContext = createContext<CompareContextType | undefined>(undefined);
export function CompareProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [compareList, setCompareList] = useState<Exchange[]>(() => {
    const saved = localStorage.getItem('compareList');
    return saved ? JSON.parse(saved) : [];
  });
  useEffect(() => {
    localStorage.setItem('compareList', JSON.stringify(compareList));
  }, [compareList]);
  const addToCompare = (exchange: Exchange) => {
    setCompareList(prev => {
      if (prev.length >= 3) {
        alert('You can only compare up to 3 exchanges at once');
        return prev;
      }
      if (prev.find(e => e.id === exchange.id)) {
        return prev;
      }
      return [...prev, exchange];
    });
  };
  const removeFromCompare = (id: string) => {
    setCompareList(prev => prev.filter(e => e.id !== id));
  };
  const clearCompare = () => {
    setCompareList([]);
  };
  const isInCompare = (id: string) => {
    return compareList.some(e => e.id === id);
  };
  return <CompareContext.Provider value={{
    compareList,
    addToCompare,
    removeFromCompare,
    clearCompare,
    isInCompare
  }} data-id="element-242">
      {children}
    </CompareContext.Provider>;
}
export function useCompare() {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within CompareProvider');
  }
  return context;
}